import React from 'react';

export const ConcesionaryRequest = {
    Header: () => 'Concesionario',
    id: 'aliado',
    Cell: ({ row }) => {
        return (
            <div>
                {row.original?.concesionario?.label
                    ? row.original?.concesionario?.label
                    : 'SIN CONCESIONARIO'}
            </div>
        );
    },
};
